import React, { useEffect, useState } from "react";
import i18n from "../../i18n";

import { Button, ControlGroup, Menu, MenuItem } from "@blueprintjs/core";
import { MultiSelect, Select } from "@blueprintjs/select";

import {
  authenticatedGetFetch,
  authenticatedGetFetchWithoutLoginRedirection,
} from "../../utils/AuthenticatedFetch";

export function parkLookup(force_update = false) {
  if (localStorage.getItem("parkLookup") !== null && !force_update) {
    return JSON.parse(localStorage.getItem("parkLookup"));
  } else {
    return new Promise((res, rej) => {
      if (localStorage.getItem("parkLookup") == null || force_update) {
        authenticatedGetFetchWithoutLoginRedirection(
          "/parks", // get hiddend park here for display if selected before hide
          (response) => {
            const lookup = {};
            for (const park of response) {
              lookup[park.id] = park.id + " - " + park.name;
              lookup[park?.server?.id + "_" + park.id] =
                park.id + " - " + park.name;
            }
            lookup[0] = "";
            localStorage.setItem("parkLookup", JSON.stringify(lookup));
            res(lookup);
          },
          null,
          () => {
            res({});
          }
        );
      } else res(JSON.parse(localStorage.getItem("parkLookup")));
    });
  }
}

export class ParkSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      srv: props.srv,
      parks: [],
      selection: props.initialValue,
    };
  }

  componentDidMount() {
    authenticatedGetFetch(
      "/parks?hidden=false" +
        (this.state.srv ? "&srvfilter=" + this.state.srv : ""),
      (response) => {
        if (this.props.filter && typeof this.props.filter === "function")
          response = response.filter(this.props.filter);
        this.setState({ parks: response });
      }
    );
  }

  render() {
    return (
      <Select
        id={this.props.id}
        items={this.state.parks}
        itemRenderer={(item, { select, modifiers }) => {
          return (
            <MenuItem
              key={"parkcomp_" + item.pk}
              label={item.id}
              text={item.name}
              onClick={() => {
                this.props.onSelect(item.id, item);
                this.setState({ selection: item });
              }}
            />
          );
        }}
        itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
          const renderedItems = items
            .map(renderItem)
            .filter(
              (item) =>
                item?.props?.text &&
                item.props.text.toUpperCase().includes(query.toUpperCase())
            );
          return (
            <Menu ulRef={itemsParentRef}>
              <MenuItem disabled={true} />
              {renderedItems}
            </Menu>
          );
        }}
      >
        <Button
          text={
            this.state.selection !== undefined
              ? this.state.selection.name +
                " (" +
                +this.state.selection.id +
                ")"
              : i18n.t("select a park")
          }
          rightIcon="double-caret-vertical"
        />
      </Select>
    );
  }
}

export function MultiParkSelect(props) {
  const [parkList, setParkList] = useState([]);
  const [parks, _setParks] = useState([]);
  const [park, setPark] = useState(parkList[0]);

  function setParks(parks) {
    _setParks(parks);
    if (props.onSelect !== undefined)
      props.onSelect(parks /* .map(park => park.pk) */);
  }

  useEffect(() => {
    authenticatedGetFetch("/parks?hidden=false", (response) =>
      setParkList(response)
    );
  }, []);

  return (
    <ControlGroup fill={true}>
      <MultiSelect
        activeItem={park}
        items={parkList}
        selectedItems={parks}
        itemRenderer={(val, itemProps) => {
          if (parks.includes(val.pk))
            return null; // hide already selected parks
          else
            return (
              <MenuItem
                key={val.pk}
                text={val?.name}
                onClick={(elm) => {
                  if (parks.includes(val.pk)) {
                    setParks(parks.filter((filtre) => filtre !== val.pk));
                  } else {
                    setPark(val.pk);
                    setParks([...parks, val.pk]);
                  }
                }}
                selected={parks.includes(val.pk)}
              />
            );
        }}
        itemListPredicate={(query, items) => {
          return items.filter((filtre) =>
            filtre?.name?.toLowerCase().includes(query?.toLowerCase())
          );
        }}
        onItemSelect={() => {}}
        tagRenderer={(pk) => parkList.filter((park) => park.pk === pk)[0]?.name}
        onRemove={(item) => {
          setParks(parks.filter((elm) => elm !== item));
        }}
        onClear={() => setParks([])}
      />
    </ControlGroup>
  );
}

export default function ParkListSelect(props) {
  const [open, setOpen] = useState(false);
  const [parks, setParks] = useState([]);

  useEffect(() => {
    authenticatedGetFetch("/parks?hidden=false", (response) =>
      setParks(response)
    );
  }, []);

  return (
    <div>
      {open ? (
        <Select
          items={parks}
          itemRenderer={(item, { select, modifiers }) => {
            return (
              <MenuItem
                key={item.id}
                label={item.id}
                text={item.name}
                onClick={() => {
                  props.onSelect(item.id, item);
                  setOpen(false);
                }}
                itemListRenderer={({
                  items,
                  itemsParentRef,
                  query,
                  renderItem,
                }) => {
                  const renderedItems = items
                    .map(renderItem)
                    .filter(
                      (item) =>
                        item != null &&
                        item.props.text != null &&
                        item.props.text
                          .toUpperCase()
                          .includes(query.toUpperCase())
                    );
                  return (
                    <Menu ulRef={itemsParentRef}>
                      <MenuItem disabled={true} />
                      {renderedItems}
                    </Menu>
                  );
                }}
              />
            );
          }}
          itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
            const renderedItems = items
              .map(renderItem)
              .filter(
                (item) =>
                  item != null &&
                  item.props.text != null &&
                  item.props.text.toUpperCase().includes(query.toUpperCase())
              );
            return (
              <Menu ulRef={itemsParentRef}>
                <MenuItem disabled={true} />
                {renderedItems}
              </Menu>
            );
          }}
        >
          <Button
            text={i18n.t("select a park to add")}
            rightIcon="double-caret-vertical"
          />
        </Select>
      ) : (
        <Button
          icon="add"
          text={props.label || ""}
          onClick={() => setOpen(true)}
        />
      )}
    </div>
  );
}
